export interface DropdownItemType {
  key: number | string;
  value: string;
  indicator?: string;
}

export enum DropdownInputType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  MINIMAL = 'MINIMAL',
  CUSTOM = 'CUSTOM',
}
